import React, { useState, useEffect, useRef, useCallback } from "react";
import { Row, Col, Container, Card } from "react-bootstrap";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import "../assets/css/Home.css";
import SEO from "../components/SEO";
import flowerBW from "../assets/images/flower_bw.svg";
import animat_video from "../assets/images/animation_video.mp4";
import animation_video from "../assets/images/animat_video.mp4";
import playbtn from "../assets/images/next.svg";
import difbundle from "../assets/images/difbundle.svg";
import halfround from "../assets/images/gifbg.png";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useNavigate } from "react-router-dom";
import api from "../api/axios";
import { FaStar } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation, Autoplay, EffectFade  } from 'swiper/modules';
import { TabView, TabPanel } from "primereact/tabview";
import nouser from "../assets/images/no_user.png";
import { Avatar } from 'primereact/avatar';
import flowerbw from "../assets/images/flower_bw.svg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ProtectedCanvasImage from "../components/ProtectedCanvasImage";


const bannerImages = [
  "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/Banner1v2%20Change.mp4",
  "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/Newbann%202%20low.mp4",
  // "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/banner2.png",
  // "https://shaadimaterial.blr1.cdn.digitaloceanspaces.com/assets/banner12.png",
];

const MainHome = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({ category_name: "", category_id: 0 });
  const [search, setSearch] = useState("");
  const [fixedSearch, setFixedSearch] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [bestSellers, setBestSellers] = useState([]);
  const [whatsNew, setWhatsNew] = useState([]);
  const [homeOccasions, setHomeOccasions] = useState([]);
  const [featuredBundles, setFeaturedBundles] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [featuredReviews, setFeaturedReviews] = useState([]);
  const searchRef = useRef(null);
  const [mobileCategories, setMobileCategories] = useState([]);

 
  /* scroll detection */

  useEffect(() => {

    const handleScroll = () => {

      if (!searchRef.current) return;

      const offset = searchRef.current.offsetTop;

      if (window.scrollY > offset) {
        setFixedSearch(true);
      } else {
        setFixedSearch(false);
      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);

  }, []);

  const [active, setActive] = useState(0);

  /*-----------------Scroll trigger--------------*/

  useEffect(() => {
    const section = document.querySelector(".category-part");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add("animate");
          }
        });
      },
      { threshold: 0.4 }
    );

    if (section) observer.observe(section);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const res = await api.get("/ProductRoutes/customer/best-sellers", {
          params: { limit: 10 },
        });
        if (res.data?.success) {
          setBestSellers(res.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch best sellers:", error);
      }
    };

    fetchBestSellers();
  }, []);

  useEffect(() => {
    const fetchWhatsNew = async () => {
      try {
        const res = await api.get("/ProductRoutes/customer/whats-new", {
          params: { limit: 12 },
        });
        if (res.data?.success) {
          setWhatsNew(res.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch what's new:", error);
      }
    };

    fetchWhatsNew();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get("/CategoryRoutes/customer/categories-with-subcategories");

        if (response.status === 200 && response.data.success) {
          const allCategoryOption = { category_name: "", category_id: 0 };
          setCategories([allCategoryOption, ...response.data.data]);
        }
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchOccasionsForHome = async () => {
      try {
        const res = await api.get(
          "/OccasionRoutes/public/fetch_occasions_for_home"
        );
        setHomeOccasions(res?.data?.data || []);
      } catch (e) {
        console.warn("Failed to fetch occasions for home:", e?.message || e);
        setHomeOccasions([]);
      }
    };

    fetchOccasionsForHome();
  }, []);

  useEffect(() => {
    const fetchFeaturedBundles = async () => {
      try {
        const res = await api.get(`/pbundles/customer/featured-products`);

        if (res.data?.success) {
          setFeaturedBundles(res.data.data || []);
        } else {
          setFeaturedBundles([]);
        }
      } catch (error) {
        console.error("Failed to fetch featured bundles:", error);
        setFeaturedBundles([]);
      }
    };

    fetchFeaturedBundles();
  }, []);

  useEffect(() => {
    const fetchFeaturedReviews = async () => {
      try {
        const res = await api.get("/productReviewRoutes/public/featured");
        if (res.data?.success) {
          setFeaturedReviews(res.data.data || []);
        }
      } catch (e) {
        console.warn("Failed to fetch featured reviews:", e?.message || e);
        setFeaturedReviews([]);
      }
    };
    fetchFeaturedReviews();
  }, []);

  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const res = await api.get(
          "/ProductRoutes/customer/random-products"
        );

        if (res.data?.success) {
          setSuggestions(res.data.data || []);
        } else {
          setSuggestions([]);
        }

      } catch (error) {
        console.error("Failed to fetch suggestions:", error);
        setSuggestions([]);
      }
    };

    fetchSuggestions();
  }, []);

  useEffect(() => {
    const fetchMobileCategories = async () => {
      try {
        const res = await api.get("/CategoryRoutes/customer/random-categories", {
          params: { limit: 9 },
        });

        if (res.data?.success) {
          setMobileCategories(res.data.data || []);
        }
      } catch (error) {
        console.error("Failed to fetch mobile categories:", error);
        setMobileCategories([]);
      }
    };

    fetchMobileCategories();
  }, []);

  const homeJsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://shaadimaterial.com/#organization",

        name: "Shaadi Material",
        url: "https://shaadimaterial.com",

        logo: {
          "@type": "ImageObject",
          url: "https://shaadimaterial.com/logo512.png",
          width: 512,
          height: 512
        },

        image: "https://shaadimaterial.com/logo512.png",

        // sameAs: [
        //   "https://www.instagram.com/YOUR_INSTAGRAM",
        //   "https://www.facebook.com/YOUR_FACEBOOK",
        //   "https://www.linkedin.com/company/YOUR_LINKEDIN",
        //   "https://www.youtube.com/@YOUR_CHANNEL",
        //   "https://in.pinterest.com/YOUR_PINTEREST"
        // ]
      },

      {
        "@type": "WebSite",
        "@id": "https://shaadimaterial.com/#website",

        url: "https://shaadimaterial.com",

        name: "Shaadi Material",

        description:
          "Premium wedding invitation templates, cliparts, monograms, illustrations, logos, vectors and digital wedding design assets.",

        publisher: {
          "@id": "https://shaadimaterial.com/#organization"
        },

        inLanguage: "en",

        potentialAction: {
          "@type": "SearchAction",
          target: "https://shaadimaterial.com/shop?search={search_term_string}",
          "query-input": "required name=search_term_string"
        }
      }
    ]
  };

  return (
    <>
      <SEO
        title="Home"
        description="Download premium wedding invitation templates, monograms, cliparts, logos, illustrations, patterns, vectors and digital design assets."
        canonical="https://shaadimaterial.com/"
        keywords="wedding invitation templates, wedding clipart, wedding monograms, logos, vectors, wedding assets, shaadi material"
        image="https://shaadimaterial.com/logo512.png"
        type="website"
        jsonLd={homeJsonLd}
      />

      <div className="wrapper p-0">

        <section className="banner-part">
          {/* <video
            className="banner-video-bg"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            <source src={animation_video} type="video/mp4" />
          </video> */}

         {/* <Swiper
            modules={[Autoplay, EffectFade]}
            effect="fade"
            loop={true}
            speed={1200}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            allowTouchMove={false}
            className="banner-video-bg"
          >
            {bannerImages.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image}
                  alt={`Banner ${index + 1}`}
                  className="banner-slide-image"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>*/}
           <Swiper
            loop={true}
            speed={2000}
            autoplay={{
              delay: 4200,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper videoswiper"
          >
            {bannerImages.map((image, index) => (
              <SwiperSlide key={index}>
                <video
                  className="banner-video-bg"
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                >
                  <source src={image} type="video/mp4" />
                </video>
              </SwiperSlide>
            ))}
          </Swiper>
          {/*<Container>

            <Row className="mx-0 banner">

              <Col md={12} className="text-center">
                 <div className="resphide">
                  <h1 data-aos="fade-down" data-aos-delay="120">
                    We Fully Support <br /> Being <span>Materialistic.</span>
                  </h1>

                  <p data-aos="fade-up" data-aos-delay="120">Especially when it comes to design mainly.</p>
                </div> */}
                {/* <div
                  ref={searchRef}
                  className={`search-wrapper ${fixedSearch ? "search-fixed" : ""}`}
                >

                  <div className="search-container" data-aos="fade-up" data-aos-delay="220">

                    <Dropdown
                      value={category}
                      options={categories}
                      optionLabel={(cat) => (cat.category_name === "" ? "All" : cat.category_name)}
                      onChange={(e) => setCategory(e.value)}
                      placeholder={`Search ${category?.category_name || "All"}...`}
                      className="search-dropdown"
                    />

                    <InputText
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Search Photos..."
                      className="search-input"
                      onKeyDown={(e) => {
                        if (e.key === "Enter") goToShopWithSearch();
                      }}
                    />

                    <i
                      className="pi pi-search search-icon"
                      onClick={goToShopWithSearch}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") goToShopWithSearch();
                      }}
                    />

                  </div>

                </div> 

                <div className="mobileicon">
                  <ul>
                    {mobileCategories.map((cat) => (
                      <li
                        key={cat.category_id}
                        onClick={() =>
                          navigate("/shop", {
                            state: { category: cat.category_name },
                          })
                        }
                      >
                        <img src={cat.image_url || flowerbw} alt={cat.category_name} />
                        <p>{cat.category_name}</p>
                      </li>
                    ))}
                  </ul>
                </div>

              </Col>

            </Row>

          </Container>*/}

        </section>
        {/*---------End_Banner--------------*/}


        {/*---------Start_What's New--------------*/}

        <section className="monthspacial">
          <Container fluid className="p-0 ps-lg-5">
            <Row className="mx-0">
              <Col md={12} className="mb-3 p-0">
                <h5 data-aos="fade-up" data-aos-delay="120">What's New</h5>
              </Col>
              <Col md={12} className="p-0 homeslider">
                <Swiper
                  slidesPerView={5.5}
                  spaceBetween={20}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[Navigation]}
                  className="mySwiper"
                  data-aos="fade-up"
                  data-aos-delay="420"

                  breakpoints={{
                    320: {
                      slidesPerView: 2.1,
                      spaceBetween: 10
                    },
                    576: {
                      slidesPerView: 3.1,
                      spaceBetween: 15
                    },
                    768: {
                      slidesPerView: 4.1,
                      spaceBetween: 20
                    },
                    992: {
                      slidesPerView: 4.5,
                      spaceBetween: 20
                    },
                    1200: {
                      slidesPerView: 5.5,
                      spaceBetween: 20
                    },
                    1600: {
                      slidesPerView: 6.5,
                      spaceBetween: 20
                    }
                  }}
                >
                  {whatsNew.map((item) => (
                    <SwiperSlide key={item.product_id}>
                      <div
                        className="slideItem"
                        onClick={() => navigate(`/product_details/${item.product_id}`)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="imageSldiv">
                          <ProtectedCanvasImage
                            src={item.thumbnail?.image_url || flowerBW}
                            alt={item.product_name || "New"}
                            width="100%"
                            height="100%"
                            objectFit="cover"
                            objectPosition="top center"
                          />
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>

        {/*---------Start_Bestsellers--------------*/}

        {bestSellers && bestSellers.length > 0 && (
          <section className="monthspacial">
            <Container fluid className="p-0 ps-lg-5">

              <Row className="mx-0">
                <Col md={12} className="mb-3 p-0">
                  <h5 data-aos="fade-up" data-aos-delay="120">Bestsellers</h5>
                </Col>
                <Col md={12} className="p-0 homeslider">
                  <Swiper
                    slidesPerView={5.5}
                    spaceBetween={30}
                     pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper bestsellerSwiper"
                    data-aos="fade-up"
                    data-aos-delay="420"

                    breakpoints={{
                      320: {
                        slidesPerView: 2.5,
                        spaceBetween: 32
                      },
                      576: {
                        slidesPerView: 3.5,
                        spaceBetween: 42
                      },
                      768: {
                        slidesPerView: 4.1,
                        spaceBetween: 52
                      },
                      992: {
                        slidesPerView: 4.5,
                        spaceBetween: 40
                      },
                      1200: {
                        slidesPerView: 4.5,
                        spaceBetween: 0
                      },
                      1600: {
                        slidesPerView: 5.5,
                        spaceBetween: 30
                      }
                    }}
                  >
                    {bestSellers.map((item) => (
                      <SwiperSlide key={item.product_id}>
                        <div
                          className="slideItem"
                          onClick={() => navigate(`/product_details/${item.product_id}`)}
                          style={{ cursor: "pointer" }}
                        >
                          <div className="imageSldiv">
                            <ProtectedCanvasImage
                              src={item.thumbnail?.image_url || flowerBW}
                              alt={item.product_name || "Best seller"}
                              width="100%"
                              height="100%"
                              objectFit="cover"
                              objectPosition="top center"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>

            </Container>
          </section>
        )}
        {/*---------Start_Monthly Occasionals--------------*/}

        {homeOccasions.length > 0 && (
          <section className="monthspacial">
            <Container fluid className="p-0 ps-lg-5">
              <Row className="mx-0">
                <Col md={12} className="mb-3 p-0">
                  <h5 data-aos="fade-up" data-aos-delay="120">Monthly Occasionals</h5>
                </Col>

                <Col md={12} className="p-0 homeslider">
                  <Swiper
                    slidesPerView={5.5}
                    spaceBetween={20}
                    pagination={{
                      dynamicBullets: true,
                      clickable: true,
                    }}
                    navigation={true}
                    modules={[Navigation]}
                    className="mySwiper"
                    data-aos="fade-up"
                    data-aos-delay="420"
                    breakpoints={{
                      320: { slidesPerView: 2.1, spaceBetween: 10 },
                      576: { slidesPerView: 3.1, spaceBetween: 15 },
                      768: { slidesPerView: 3.1, spaceBetween: 20 },
                      992: { slidesPerView: 4.5, spaceBetween: 20 },
                      1200: { slidesPerView: 5.5, spaceBetween: 20 },
                      1600: { slidesPerView: 6.5, spaceBetween: 20 },
                    }}
                  >
                    {homeOccasions.map((o, idx) => (
                      <SwiperSlide key={`monthly-occasion-${o.id || idx}`}>
                        <div
                          className="slideItem"
                          onClick={() =>
                            navigate("/shop", { state: { occasion_id: o.id } })
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <div className="imageSldiv">
                            <img
                              src={o.cover_image_url || flowerBW}
                              alt={o.occasion_name || "occasion"}
                            />
                          </div>

                          <h6>{o.occasion_name}</h6>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Col>
              </Row>
            </Container>
          </section>
        )}

        {/*---------Start_Suggestions--------------*/}

        <section className="monthspacial">
          <Container fluid className="p-0 ps-lg-5">
            <Row className="mx-0">
              <Col md={12} className="mb-3 p-0">
                <h5 data-aos="fade-up" data-aos-delay="120">Suggestions</h5>
              </Col>
              <Col md={12} className="p-0 homeslider">
                <Swiper
                  slidesPerView={5.5}
                  spaceBetween={20}
                  pagination={{
                    dynamicBullets: true,
                    clickable: true,
                  }}
                  navigation={true}
                  modules={[Navigation]}
                  className="mySwiper"
                  data-aos="fade-up"
                  data-aos-delay="420"

                  breakpoints={{
                    320: {
                      slidesPerView: 2.1,
                      spaceBetween: 10
                    },
                    576: {
                      slidesPerView: 3.1,
                      spaceBetween: 15
                    },
                    768: {
                      slidesPerView: 3.1,
                      spaceBetween: 20
                    },
                    992: {
                      slidesPerView: 4.5,
                      spaceBetween: 20
                    },
                    1200: {
                      slidesPerView: 5.5,
                      spaceBetween: 20
                    },
                    1600: {
                      slidesPerView: 6.5,
                      spaceBetween: 20
                    }
                  }}
                >
                  {(suggestions.length > 0
                    ? suggestions
                    : Array.from({ length: 8 })
                  ).map((item, index) => {

                    if (!item) {
                      return (
                        <SwiperSlide key={`suggestion-placeholder-${index}`}>
                          <div className="imageSldiv">
                            <img src={flowerBW} alt="placeholder" />
                          </div>
                        </SwiperSlide>
                      );
                    }

                    return (
                      <SwiperSlide key={item.product_id}>
                        <div
                          className="slideItem"
                          onClick={() =>
                            navigate(`/product_details/${item.product_id}`)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <div className="imageSldiv">
                            <ProtectedCanvasImage
                              src={
                                item.thumbnail?.image_url ||
                                flowerBW
                              }
                              alt={item.product_name || "Suggestion"}
                              width="100%"
                              height="100%"
                              objectFit="cover"
                              objectPosition="top center"
                            />
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </Col>
            </Row>
          </Container>
        </section>

        {/*---------Start_Bundle--------------*/}

        {featuredBundles.length > 0 && (
          <section className="BundleForm pb-0">
            <Container fluid className="p-0 ps-lg-5">
              <Row className="mx-0 Bundlediv">
                <Col md={12} className="mb-3 p-0">
                  <h5 data-aos="fade-up" data-aos-delay="120">Bundles</h5>
                </Col>

                <Col md={12} className="text-center p-0">
                  <Swiper
                    spaceBetween={20}
                    slidesPerView={4.5}
                    loop={false}
                    navigation
                    pagination={{ type: "fraction" }}
                    breakpoints={{
                      0: { slidesPerView: 1.2 },
                      576: { slidesPerView: 2.2 },
                      768: { slidesPerView: 3.5 },
                      1024: { slidesPerView: 4.5 },
                    }}
                  >
                    {featuredBundles.map((bundle) => {
                      const bundleImage =
                        [...(bundle.images || [])].sort(
                          (a, b) => (a.order_no || 0) - (b.order_no || 0)
                        )[0]?.image_url || difbundle;

                      return (
                        <SwiperSlide key={bundle.product_bundle_id}>
                          <div
                            className="bundle-slide"
                            onClick={() =>
                              navigate(
                                `/bundleproductdetails/${bundle.product_bundle_id}`
                              )
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={bundleImage}
                              alt={bundle.bundle_name || "bundle"}
                              className="w-100"
                            />

                            <Button
                              label={bundle.bundle_name || "BUNDLE"}
                              className="bundlebutton"
                            />
                          </div>
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
                </Col>
              </Row>
            </Container>
          </section>
        )}

        {/*---------Start_Accordion--------------*/}

        <section className="designsStand pb-6">
          <Container>
            <Row className="mx-0 justify-content-center Stand_div">
              <Col md={12} className="text-center mb-3 d-block p-0">
                <h2 data-aos="fade-up" data-aos-delay="120">Frequently   <br /><span>Asked Questions</span></h2>
              </Col>
              <Col md={9} className="p-0 ">
                <div className="faqSection">
                  <Accordion activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>

                    <AccordionTab header="Do I need to subscribe to use the site?">
                      <p>
                        You can browse and explore everything for free. A subscription is only needed when you want to download a design.
                      </p>
                    </AccordionTab>

                    <AccordionTab header="What do I get with a subscription?" >
                      <p>
                        A coin balance you can use to download any design from our library, across all categories and sub-categories, in PNG or PSD format.  
                      </p>
                    </AccordionTab>

                     <AccordionTab header="Can I cancel my subscription anytime?" >
                      <p>
                        Monthly plans, yes. Cancel anytime and use your remaining coins until that billing month ends. Your subscription simply won't start again until you purchase it fresh.
                      </p>
                      <p>
                       Annual plans can be cancelled mid-term, but your coin balance gets frozen and the plan won't auto-renew the next year. You also have the option to turn off auto-renew separately, if you'd rather stop it in advance.
                      </p>
                    </AccordionTab>
                     <AccordionTab header="If I cancel, do I get a refund?" >
                       <p>
                        No, cancelling only stops your next renewal, it doesn't refund your current billing period. If you haven't downloaded anything and you're within the cooling-off window, you may be eligible; see our Refund Policy for details.
                       </p>
                    </AccordionTab>
                     <AccordionTab header="Can I use the designs for client or commercial projects?" >
                       <p>
                        Yes. Personal and commercial use is both allowed, including client work, as long as it follows the usage rules in our Terms of Use.
                       </p>
                    </AccordionTab>
                     <AccordionTab header="Do I need profession design skills to use these files?" >
                      <p>
                          No professional design experience needed, just basic editing skills or a tool like Canva. Drop the PNG straight into your layout or If you prefer more control, the PSD files let you edit and customize. 
                      </p>
                    </AccordionTab>
                     <AccordionTab header="Who is this site for?" >
                        <p>
                          Designers, wedding and event planners, and anyone planning a wedding and even last-minute, who needs ready-made design assets fast.

                        </p>
                    </AccordionTab>
                     <AccordionTab header="Can I request a specific design or theme?" >
                       <p>
                          No, we don’t take custom design requests. Every element on Shaadi Material is hand-illustrated and offered as a finished, ready-to-download asset that you can use as-is.
                       </p>
                       <p>
                        Looking for something completely custom? You can always reach out to @grapheweddings on Instagram for bespoke wedding design services.
                       </p>
                    </AccordionTab>
                     {/* <AccordionTab header="Do you offer a free trial or free content to try first?" >
                         <p>
                          Yes, we do provide a 7-day free trial. If you don't cancel within those 7 days, it automatically continues as your chosen monthly or annual plan. Cancel within the trial window, and we'll reissue your refund. 
                         </p>
                    </AccordionTab> */}
                     <AccordionTab header="Do unused coins expire?" >
                          <p>
                            No, they roll over to your next billing cycle as long as your subscription stays active. If you cancel or your plan lapses, any rolled-over balance is not retained. 
                          </p>
                    </AccordionTab>
                    <AccordionTab header="Can I switch from monthly to annual (or the other way around)?" >
                          <p>
                            Yes. You can upgrade or switch plans from your account settings. The moment you switch, your monthly subscription ends and your annual plan begins from that day, running for a full year from the switch date. Any coins you already had, say, 500 from your monthly plan, stay in your balance, and the annual plan's coins get added on top. Nothing you've already earned is lost in the switch. 
                          </p>
                          <p><b>Why Choose Shaadi Material</b></p>
                          <ol>
                            <li>Made for weddings, not stock photography. Every asset here is designed with weddings and events in mind, not generic clipart repurposed to fit. What you see is what your project actually needs.</li>
                            <li>No design skills required. Everything is ready to use the moment you download it. Know your way around editing tools? The PSD files give you full control too.</li>
                            <li>You only pay for what you use. Every design shows its coin cost upfront. No bulk packs, no bundles you'll never touch, just download what your project needs.</li>
                            <li>On a monthly plan, you can cancel whenever you like and continue enjoying your membership until your current billing period ends—with no cancellation fees or hassle.</li>
                            <li>Built for speed. Planning last-minute? Browse, download and done in minutes, not days. No back-and-forth with a designer required.</li>
                            <li>Two formats, zero compromise. PNG when you need it fast, PSD when you need to make it yours. Every download comes both ways.</li>
                          </ol>
                    </AccordionTab>

                  </Accordion>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/*---------Start_designs_stand--------------*/}
        <section className="designsStand d-none">
          <Container className="p-lg-0">
            <Row className="mx-0 Stand_div">
              <Col md={12} className="text-center mb-3 d-block p-0">
                <h2 data-aos="fade-up" data-aos-delay="120">Customer <span>Reviews</span></h2>
              </Col>
              <Col md={12} className="p-0 pt-lg-5 pt-4">
                {/* <ul
                  className={`design-grid${featuredReviews.length > 0 ? " design-grid--reviews" : ""
                    }`}
                >
                  {(featuredReviews.length > 0
                    ? featuredReviews
                    : Array.from({ length: 6 })
                  ).map((item, index) => {
                    if (!item || typeof item === "number") {
                      return (
                        <li
                          key={`review-ph-${index}`}
                          data-aos="fade-up"
                          data-aos-delay={index * 120}
                          data-aos-duration="900"
                        >
                          <div className="desdiv">
                            <img src={flowerBW} alt="" />
                          </div>
                        </li>
                      );
                    }
                    return (
                      <li
                        key={item.product_review_id || index}
                        data-aos="fade-up"
                        data-aos-delay={index * 120}
                        data-aos-duration="900"
                      >
                        <div
                          className="desdiv review-card-body"
                          style={{
                            cursor: item.product?.product_id ? "pointer" : "default",
                          }}
                          onClick={() =>
                            item.product?.product_id &&
                            navigate(`/product_details/${item.product.product_id}`)
                          }
                          role={item.product?.product_id ? "link" : undefined}
                          tabIndex={item.product?.product_id ? 0 : undefined}
                          onKeyDown={(e) => {
                            if (
                              item.product?.product_id &&
                              (e.key === "Enter" || e.key === " ")
                            ) {
                              e.preventDefault();
                              navigate(`/product_details/${item.product.product_id}`);
                            }
                          }}
                        >
                          <div className="review-card-header">
                            <span className="review-card-stars" aria-hidden>
                              {"★".repeat(item.rating || 0)}
                            </span>
                            <span className="review-card-name">
                              {item.reviewer_display_name}
                            </span>
                          </div>
                          <p className="review-card-text">{item.body}</p>
                          {item.product?.product_name && (
                            <div className="review-card-meta">

                              <span className="review-card-meta-label">
                                Reviewed product
                              </span>

                              <span className="review-card-product">
                                {item.product.product_name}
                              </span>

                              {item.product?.thumbnail_url && (
                                <div className="review-card-thumbnail">
                                  <img
                                    src={item.product.thumbnail_url}
                                    alt={item.product.product_name || "Product thumbnail"}
                                    className="review-thumbnail-img"
                                    loading="lazy"
                                    onError={(e) => {
                                      e.currentTarget.src = flowerBW;
                                    }}
                                  />
                                </div>
                              )}

                            </div>
                          )}
                        </div>
                      </li>
                    );
                  })}
                </ul> */}

                {/* <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={4}
                  navigation
                  pagination={{ clickable: true }}
                  loopAdditionalSlides={4}
                  speed={800}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 2 },
                    768: { slidesPerView: 3 },
                    1024: { slidesPerView: 4 },
                  }}
                >
                  {(featuredReviews.length > 0
                    ? featuredReviews
                    : Array.from({ length: 6 })
                  ).map((item, index) => {
                    if (!item || typeof item === "number") {
                      return (
                        <SwiperSlide key={`review-ph-${index}`}>
                          <div
                            data-aos="fade-up"
                            data-aos-delay={index * 120}
                            data-aos-duration="900"
                          >
                            <div className="desdiv">
                              <img src={flowerBW} alt="" />
                            </div>
                          </div>
                        </SwiperSlide>
                      );
                    }

                    return (
                      <SwiperSlide key={item.product_review_id || index}>
                        <div
                          data-aos="fade-up"
                          data-aos-delay={index * 120}
                          data-aos-duration="900"
                        >
                          <div
                            className="review-card-body"
                            style={{
                              cursor: item.product?.product_id ? "pointer" : "default",
                            }}
                            onClick={() =>
                              item.product?.product_id &&
                              navigate(`/product_details/${item.product.product_id}`)
                            }
                            role={item.product?.product_id ? "link" : undefined}
                            tabIndex={item.product?.product_id ? 0 : undefined}
                            onKeyDown={(e) => {
                              if (
                                item.product?.product_id &&
                                (e.key === "Enter" || e.key === " ")
                              ) {
                                e.preventDefault();
                                navigate(`/product_details/${item.product.product_id}`);
                              }
                            }}
                          >
                            {item.product?.product_name && (
                              <div className="review-card-meta">
                                {item.product?.thumbnail_url && (
                                  <div className="desdiv review-card-thumbnail">
                                    <img
                                      src={item.product.thumbnail_url}
                                      alt={item.product.product_name || "Product thumbnail"}
                                      className="review-thumbnail-img"
                                      loading="lazy"
                                      onError={(e) => {
                                        e.currentTarget.src = flowerBW;
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                            )}
                            <div className="p-2">
                              <p className="review-card-text">{item.body}</p>
                              <div className="review-card-header d-flex justify-content-between align-items-center">
                                <span className="review-card-stars text-pink">
                                  {"★".repeat(item.rating || 0)}
                                </span>
                                <span className="review-card-name">
                                  {item.reviewer_display_name}
                                </span>
                              </div>


                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper> */}

                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  spaceBetween={20}
                  navigation
                  loop={true}
                  slidesPerView={3}
                  loopAdditionalSlides={3}
                  speed={1000}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  pagination={{
                    clickable: true,
                  }}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    576: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                  }}

                  className="testimonialSwiper"
                >
                  <SwiperSlide>
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.google.com/maps/place/?q=place_id=YOUR_PLACE_ID",
                          "_blank"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <h4>“I love this product. It’s so beautiful and it’s made of high quality materials.”</h4>
                      <span className="review-card-stars text-pink d-flex justify-content-center gap-1 mb-3 mt-4">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </span>
                      <div>
                        <Avatar image={nouser} className="mr-2" size="large" shape="circle" />
                        <p>— John Doe, <small className="d-block">CEO of XYZ Company</small></p>
                      </div>

                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.google.com/maps/place/?q=place_id=YOUR_PLACE_ID",
                          "_blank"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <h4>“I love this product. It’s so beautiful and it’s made of high quality materials.”</h4>
                      <span className="review-card-stars text-pink d-flex justify-content-center gap-1 mb-3 mt-4">
                        <FaStar /><FaStar /><FaStar /><FaStar />
                      </span>
                      <div>
                        <Avatar image={nouser} className="mr-2" size="large" shape="circle" />
                        <p>— John Doe, <small className="d-block">CEO of ABC Company</small></p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.google.com/maps/place/?q=place_id=YOUR_PLACE_ID",
                          "_blank"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <h4>“This product is amazing. It’s so beautiful and it’s made of high quality materials.”</h4>
                      <span className="review-card-stars text-pink d-flex justify-content-center gap-1 mb-3 mt-4">
                        <FaStar /><FaStar /><FaStar /><FaStar /><FaStar />
                      </span>
                      <div>
                        <Avatar image={nouser} className="mr-2" size="large" shape="circle" />
                        <p>— John Doe, <small className="d-block">CEO of XYZ Company</small></p>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div
                      onClick={() =>
                        window.open(
                          "https://www.google.com/maps/place/?q=place_id=YOUR_PLACE_ID",
                          "_blank"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <h4>“I love this product. It’s so beautiful and it’s made of high quality materials.”</h4>
                      <span className="review-card-stars text-pink d-flex justify-content-center gap-1 mb-3 mt-4">
                        <FaStar /><FaStar /><FaStar /><FaStar />
                      </span>
                      <div>
                        <Avatar image={nouser} className="mr-2" size="large" shape="circle" />
                        <p>— John Doe, <small className="d-block">CEO of ABC Company</small></p>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>

              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
};

export default MainHome